<template>
  <div>
    <nav class="sidebar-right--tabs">
      <div :class="{ active: sidebarActiveTab === 'notification' }" @click="changeTab('notification')">
        {{ $t("common.notifications") }}
      </div>

      <div :class="{ active: sidebarActiveTab === 'question' }" @click="sidebarActiveTab = 'question'">
        {{ $t("question-set.my") }}
      </div>
    </nav>

    <div class="sidebar-right--tab-content">
      <div class="sidebar-right--wrapper" :class="{ active: sidebarActiveTab === 'notification' }">
        <div v-if="notificationPagination">
          <div class="line" v-if="notificationPagination.docs.length > 0"></div>
          <div class="sidebar-right--item" v-for="item in notificationPagination.docs" :key="item._id">
            <div class="d-flex">
              <div :class="['icon', getIconColorClass(item.type)]"><i class="iconoir-bell-notification"></i></div>
              <div>
                <div class="text">{{ item.title | translate }}</div>
                <div class="d-flex align-items-center" style="gap: 0.38rem;">
                  <div class="date">{{ item.at | date(true) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <template>
              <div class="d-flex justify-content-center my-3">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    v-model="notificationRequest.options.page"
                    :total-rows="notificationPagination.totalDocs"
                    :per-page="notificationPagination.limit"
                    limit="5"
                    size="sm"
                  ></b-pagination>
                </ul>
              </div>
            </template>
          </div>
        </div>

        <empty v-if="!notificationLoading && (!notificationPagination || notificationPagination.docs.length == 0)">
          <h5 class="text-center" id="myText">
            {{ $t("notification.empty") }}
          </h5>
        </empty>

        <content-loading v-if="notificationLoading" />
      </div>

      <div class="p-3" :class="{ active: sidebarActiveTab === 'question' }">
        <div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sidebarActiveTab: "notification",
      nameFilter: undefined,

      notificationRequest: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
    };
  },
  watch: {
    notificationRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.paginateNotification();
      },
    },

    questionRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.paginateNotification();
      },
    },
  },
  computed: {
    notificationPagination() {
      return this.$store.getters["organizationNotification/pagination"];
    },

    questionPagination() {
      return this.$store.getters["question/questionPagination"];
    },
    selectedWorkspace() {
      return this.$store.getters["organization/selected"];
    },
    notificationLoading() {
      return this.$store.getters[`organizationNotification/isLoading`];
    },
  },
  methods: {
    changeTab(tab) {
      this.sidebarActiveTab = tab;
    },
    paginateNotification() {
      if (this.selectedWorkspace) {
        this.$store.dispatch("organizationNotification/paginate", this.notificationRequest);
      }
    },
    paginateQuestion() {},

    getIconColorClass(type) {
      switch (type) {
        case "ERROR":
          return "text-danger";
        case "INFO":
          return "text-primary";
        case "NEWS":
          return "text-info";
        case "SUCCESS":
          return "text-success";
        case "WARNING":
          return "text-warning";
        default:
          return "text-dark";
      }
    },
  },
};
</script>

<style scoped></style>
